import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Iphone() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Three.js", "Blender", "", "", "", ""];
    const infoProyect = [
        "Iphone 3D",
        "https://www.youtube.com/embed/WgoTgGQXdMg",
        "Cell phone sample where you can play a You Tube video",
        "https://brandongrimaldom.github.io/iphone/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Iphone;